
<template >

<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="推广会员榜" name="first" :lazy="true">
        <member-ranking ref="member-ranking"></member-ranking>
    </el-tab-pane>
    <el-tab-pane label="推广经纪人榜" name="second" :lazy="true">
        <agent-ranking ref="agent-ranking"></agent-ranking>
    </el-tab-pane>
    <el-tab-pane label="推广收益榜" name="third" :lazy="true">
        <profit-ranking ref="profit-ranking"></profit-ranking>
    </el-tab-pane>
    <el-tab-pane label="有效招商榜" name="fourth" :lazy="true">
        <business-ranking ref="business-ranking"></business-ranking>
    </el-tab-pane>

</el-tabs>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import memberRanking from './memberRanking'
import agentRanking from './agentRanking'
import profitRanking from './profitRanking'
import businessRanking from './businessRanking'

export default {
  name: 'member-tab-index',
  extends: BasicPager,
  data () {
    return {
      isAdmin: false,
      activeName: 'first'
    }
  },
  created: function () {
    if (this.$route.params.type) {
      this.activeName = this.$route.params.type
    }
  },
  mounted: function () {

  },
  components: {
    memberRanking,
    agentRanking,
    profitRanking,
    businessRanking
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}

</script>
